import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
 
@Component({
  selector: 'app-fee-templet-dialog-box',
  templateUrl: './fee-templet-dialog-box.component.html',
  styleUrls: ['./fee-templet-dialog-box.component.scss'],
})
export class FeeTempletDialogBoxComponent implements OnInit {
  feeTempletForm: FormGroup;
  list;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  SubCast = false;
  isDelete = false;
  FTdisable = false;
  isUpdate = false;
  purposeList: any;
  filteredpurposeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  stuStatusList: any;
  filteredstuStatusList: any;
  filteredAdModeList: any;
  AdModeList: any;
  categoryList: any;
  filteredCategoryList: any;
  submitpayload: any;
  FeeTempletList: any;
  FeeTemplateId: any;
  APIService: string;
  castList: any;
  feeHeadArray: FormArray;
  filteredcastList: any;
  SRList: any;
  Table = true;
  filteredSR: any;
  FeeHeadList: any;
  CurrencyList: any;
  filteredCurrencyList: any;
  filteredHeadList: any;
  myFormValueChanges;
  FeeTable: any;
  lvl: 0;
  arr = [];
  inputTimeout: any;
  totalAmount = 0;
  values: any;
  arrTest: any = [];
  FeesTable = [];
  FeesGrid: any;
  errMsg: any;
  feeList: any;
  filteredfeeList: any;
  feeCreate = true;
  feeUpdate = true;
  feeDelete = true;
  FeeLvlShow = false;
  FeeExam = false;
  StuType = true;
  StuStatus = true;
  AdmMode = true;
  ScRes = true;
  Handi = true;
  ScQuota = true;
  Cast = true;
  Curr = true;
  userPermission: any;
  utp: any;
  headdList: any[] = [];
  filteredheaddList: any[] = [];
  tbRow: any[] = [];
  availableOptions: any[] = []; // Make a copy of the original JSON data
  selectedOptions: any[] = [];
  arrayy;
  FeeTemplateSearch: FormGroup;
  feeTempList: any;
  FeeType: string;
  feeLvlList: any;
  filteredfeeLvlList: any;
  examList: any;
  filteredListExam: any;
  falseForExam: boolean;
  feeType: any;
  showFeeType: boolean;
  ExamFeeTypeList: any;
  filteredExamFeeTypeList: any;
  isFeeType =true;
  SessionNo: any;
  courseType: any;
  formattedDate: string;
  formattedDate2: string;
  showDateInfoMsg = false;
  dateInfoMsg = '';
  originalFeeDates = [];
  disableDate = false;
  currentdate;
  date: string;
  sessionCutoffFrom!: Date | null;
  sessionCutoffTo!: Date | null;
  cutoffLoaded = false;
  ExamInputList: any;
  filteredExamInputList: any;
  ExamAList: any;
  filteredExamAList: any;
  selectedInCode: string = '';
  lockSchemaOptions = false;
  isOldStudentSelected = false;
  resPending: boolean = false;

  constructor(
    public umsService: UmsService,
    public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<FeeTempletDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }
  dialogRef: MatDialogRef<any>;
  todayDate: Date = new Date();
  ngOnInit(): void {
    this.FeeType = '';
    window.scroll(0, 0);
    this.SubCast = false;
    this.FeeLvlShow = false;
    this.FeeExam = false;
    this.StuType = true;
    this.StuStatus = true;
    this.AdmMode = true;
    this.ScRes = true;
    this.Handi = true;
    this.ScQuota = true;
    this.Cast = true;
    this.Curr = true;
    this.arr = [];
    this.currentdate = new Date().setHours(0, 0, 0, 0);
    this.date = this.datepipe.transform(this.currentdate, 'yyyy-MM-dd');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach((element) => {
        if (element.PageName == 'Fee Template' && element.PCreate == false) {
          this.feeCreate = false;
        }
        if (element.PageName == 'Fee Template' && element.PUpdate == false) {
          this.feeUpdate = false;
        }
        if (element.PageName == 'Fee Template' && element.PDelete == false) {
          this.feeDelete = false;
        }
      });
    }
        if (JSON.parse(sessionStorage.getItem("session")) == null) {
        this.fetchSecretData();
        }
        else if (JSON.parse(sessionStorage.getItem("session")) != null) {
        let sessionData = JSON.parse(sessionStorage.getItem("session"));
        this.SessionNo = sessionData.SnNo
        }

    this.list = true;
    this.lvl = 0;
    this.totalAmount = 0;
    this.feeTempletForm = this.fb.group({
      TemplateName: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
      ]),
      TemplateCode: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
      ]),
      StudentType: new FormControl('', [Validators.required]),
      StudentStatus: new FormControl('', [Validators.required]),
      constitutional: new FormControl('', [Validators.required]),
      // Caste: new FormControl(''),
      FeeType: new FormControl('', [Validators.required]),
      EmFeeType: new FormControl(''),
      FeeLevel: new FormControl(''),
      EmId: new FormControl(''),
      EmFeeFromDate: new FormControl(''),
      EmFeeToDate: new FormControl(''),
      SocialReservation: new FormControl('', [Validators.required]),
      IsHandicap: new FormControl('', [Validators.required]),
      SchemaQuota: new FormControl('', [Validators.required]),
      AdmissionMode: new FormControl('', [Validators.required]),
      feeHeadArray: new FormArray([]),
      Currency: new FormControl('', [Validators.required]),
    });
    this.action('fee');
    this.fetchSupExamInputs();
    this.fetchStudentType();
    this.fetchStudentStatus();
    this.fetchAddmissionMode();
    this.getFeeTempletData('');
    this.fetchConstiCast();
    this.fetchSocialReservation();
    this.fetchCurrency();
    this.getFeeHeadData();
    this.getExamList();
    this.addNewRow();
    this.fetchFeeType();
    this.feeTempletForm.controls['Currency'].setValue('INR');
    if (this.data.key == 'Edit' || this.data.key == 'Delete') {
  this.ExamFeeType(() => {
    if (this.data.key == 'Edit') {
      this.prepopulation(this.data.selected);
      this.courseType = this.data.selected.CourseType;
    } else if (this.data.key == 'Delete') {
      this.prepopulationForDelete(this.data.selected);
    }
  });
}
     else {
      // alert(this.data.key)
    }
    this.FeeTemplateSearch = this.fb.group({
      SearchString: new FormControl(''),
    });
    // if (this.data.key == "Edit") {
    //   this.prepopulation(this.data.selected);
    // } else if (this.data.key == "Delete") {
    //   this.prepopulationForDelete(this.data.selected);
    // } else {
    //   // alert(this.data.key)
    // }

    // Subscribe to changes in the form array
    this.feeTempletForm.get('feeHeadArray').valueChanges.subscribe((values) => {
      this.checkForDuplicates(values);
    });
  }

onSchemaQuotaChange(values: any) {

  const arr: string[] = Array.isArray(values) ? values : [values];

  const isOldStudent = arr.includes('OS');
  this.isOldStudentSelected = isOldStudent;

  if (isOldStudent) {

    this.lockSchemaOptions = true;

    this.feeTempletForm.patchValue({
    SchemaQuota: ['OS']
    }, { emitEvent: false });

    this.feeTempletForm.patchValue({
    StudentType: ['NA'],
    StudentStatus: ['NA'],
    SocialReservation: ['NA'],
    constitutional: ['GM'],
    IsHandicap: false, 
    Currency: 'INR'
    }, { emitEvent: false });

    [
      'StudentType',
      'StudentStatus',
      'SocialReservation',
      'IsHandicap',
      'constitutional',
      'Currency'
    ].forEach(c => {
      this.feeTempletForm.get(c)?.disable({ emitEvent: false });
    });

      this.toggleFlags({
      StuType: true,
      StuStatus: true,
      ScRes: true,
      Handi: true,
      Cast: true,
      Curr: true
    });

    return;
  }

    this.lockSchemaOptions = false;
    this.isOldStudentSelected = false;

    [
      'StudentType',
      'StudentStatus',
      'SocialReservation',
      'IsHandicap',
      'constitutional',
      'Currency'
    ].forEach(c => {
      this.feeTempletForm.get(c)?.enable({ emitEvent: false });
    });

      this.toggleFlags({
      StuType: true,
      StuStatus: true,
      ScRes: true,
      Handi: true,
      Cast: true,
      Curr: true
    });
}

  getFormControls() {
    return (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
  }

  action(fee) {
    let taskListArrays = this.feeTempletForm.get('feeHeadArray') as FormArray;
    if (taskListArrays.length >= 2) {
      let ttsskk = taskListArrays.length - 1;
      for (let index = 0; index <= ttsskk; index++) {
        const element = taskListArrays.controls[index];
        if (element.status == 'INVALID') {
          taskListArrays.controls[index].get('EmFeeToDate').setErrors(null)
          taskListArrays.controls[index].get('EmFeeFromDate').setErrors(null)
        }
      }
    }
  }

  datechange(i: number) {
  const fa = this.feeTempletForm.get('feeHeadArray') as FormArray;
  const row = fa.at(i);

  const from = row.value.EmFeeFromDate;
  const to = row.value.EmFeeToDate;

  if (from && to && from > to) {
    row.get('EmFeeFromDate')?.setErrors({ fromGreater: true });
  } else {
    row.get('EmFeeFromDate')?.setErrors(null);
  }

  if (i > 0) {
    const prevTo = fa.at(i - 1).value.EmFeeToDate;
    if (from && prevTo && from <= prevTo) {
      row.get('EmFeeFromDate')?.setErrors({ overlap: true });
    }
  }
}

  datechange1(i: number) {
  const fa = this.feeTempletForm.get('feeHeadArray') as FormArray;
  const row = fa.at(i);

  const from = row.value.EmFeeFromDate;
  const to = row.value.EmFeeToDate;

  if (from && to && to <= from) {
    row.get('EmFeeToDate')?.setErrors({ dateError: true });
  } else {
    row.get('EmFeeToDate')?.setErrors(null);
  }
}


  isDatePassed(cutOffDate: Date): boolean {
    const todayDate = new Date();
    const cutOff = new Date(cutOffDate);

    todayDate.setHours(0, 0, 0, 0);
    cutOff.setHours(0, 0, 0, 0);

    return cutOff < todayDate;
  }

  formatDate(d: Date): string {
  if (!d) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
}

// dateFilter = (d: Date | null): boolean => {
//   if (!d || !this.cutoffLoaded) return false;

//   return d >= this.sessionCutoffFrom && d <= this.sessionCutoffTo;
// };

dateFilter = (d: Date | null): boolean => {
  if (!d || !this.cutoffLoaded) return false;

  const date = this.normalize(d);
  const from = this.normalize(this.sessionCutoffFrom);
  const to   = this.normalize(this.sessionCutoffTo);

  return date >= from && date <= to;
};

private normalize(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

onFeeTypeChange(emFeeType: string, index: number) {
  this.cutoffLoaded = false;
  this.showDateInfoMsg = false;

  this.getdates(emFeeType, index);
}

  keypress() {
    this.umsService.searchFeeTemplate(this.FeeTemplateSearch.value).subscribe(
      (res) => {
        this.FeeTempletList = res.data;
      },
      (ERROR: HttpErrorResponse) => {
        this.FeeTempletList = [];
      }
    );
  }

  getfeeHeadArrayControls() {
    return (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
  }

  getFeeTempletData(id) {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = id.TemplateCode;
    payload['FeeType'] = '';
    this.umsService.getFeeTemplet(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.FeeTempletList = res.data;
        } else {
          this.spinner.hide();
          this.FeeTempletList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.FeeTempletList = [];
      }
    );
  }

  addNewRow2(i, e) {
    this.arr = this.feeTempletForm.controls.feeHeadArray.value;
    this.feeHeadArray = this.feeTempletForm.get('feeHeadArray') as FormArray;
        if (this.feeHeadArray.length >= this.ExamFeeTypeList.length) {
      let data = {};
      data['message'] = 'All available Fee Types have already been added.';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-info-circle';

      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      console.log('this.feeHeadArray', this.feeHeadArray)
      console.log('this.ExamFeeTypeList', this.ExamFeeTypeList)
      return;
    }
    if (this.feeHeadArray.invalid) {
      this.feeHeadArray.controls.forEach((element) => {
        element.get('FeeHead').markAsTouched();
        // element.get('ClgUni').markAsTouched();
        // element.get('Purpose').markAsTouched();
        element.get('FeeAmount').markAsTouched();
      });
    } else {
      this.lvl = this.feeTempletForm.controls.feeHeadArray.value.length;
      this.arr = this.feeTempletForm.controls.feeHeadArray.value;
      const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
      creds.push(
        this.fb.group({
          FeeHead: new FormControl('', [Validators.required]),
          ClgUni: new FormControl(''),
          Purpose: new FormControl(''),
          FeeAmount: new FormControl('', [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
          ]),
          EmFeeType: new FormControl(''),
          EmFeeFromDate: new FormControl(''),
          EmFeeToDate: new FormControl(''),
          EmFeeTotal: new FormControl(''),
        })
      );
      // if(this.lvl >= 1){
      //  this.FeeHeadList =  this.headdList[i] ;
      // }
    }
  }
  errorcheckP(i) {
    return (
      i.controls['FeeAmount'].touched && i.controls['FeeAmount'].errors?.pattern
    );
  }
  errorcheckR(i) {
    return (
      i.controls['FeeAmount'].touched &&
      i.controls['FeeAmount'].errors?.required
    );
  }

  errorcheckH(i) {
    return (
      i.controls['FeeHead'].touched && i.controls['FeeHead'].errors?.required
    );
  }

  addNewRow() {
    const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
    creds.push(
      this.fb.group({
        FeeHead: new FormControl('', [Validators.required]),
        ClgUni: new FormControl(''),
        Purpose: new FormControl(''),
        FeeAmount: new FormControl('', [
          Validators.required,
          Validators.pattern('^[0-9]*$'),
        ]),
         EmFeeType: new FormControl(''),
         EmFeeFromDate: new FormControl(''),
         EmFeeToDate: new FormControl(''),
      })
    );
  }

  checkForDuplicates(values: any) {
    const duplicates = values.filter(
      (value, index, self) =>
        index !== self.findIndex((v) => v.FeeHead === value.FeeHead)
    );

    if (duplicates.length) {
      const data = {
        message: 'Fee Head Already Selected',
        title: 'Information',
        icon: 'fas fa-box-open',
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );

      // Remove duplicate selections
      duplicates.forEach((duplicate) => {
        const index = values.findIndex((v) => v.FeeHead === duplicate.FeeHead);
        const arrayy = this.feeTempletForm.get('feeHeadArray') as FormArray;
        arrayy.at(index).get('FeeHead').setValue('');
      });
    } else {
      this.arr = this.feeTempletForm.controls.feeHeadArray.value;
    }
  }

  isSelected(feehead: string): boolean {
    return this.arr.some((element) => element.FeeHead === feehead);
  }

  isSelectedCode(EmFeeType: string): boolean {
    return this.arr.some((element) => element.EmFeeType === EmFeeType);
  }

  deleteRow(index) {
    if (index !== 0) {
      let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
        .at(index)
        .get('FeeAmount').value;

      if (amountValue == '') {
        amountValue = 0;
      } else {
        amountValue = parseInt(amountValue);
        this.totalAmount = this.totalAmount - parseInt(amountValue);
      }

      (<FormArray>this.feeTempletForm.get('feeHeadArray')).removeAt(index);
      this.arr = this.feeTempletForm.controls.feeHeadArray.value;
    } else {
      let length = this.feeTempletForm.get('feeHeadArray').value.length;
      if (length > 1) {
        let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
          .at(index)
          .get('FeeAmount').value;

        if (amountValue == '') {
          amountValue = 0;
        } else {
          amountValue = parseInt(amountValue);
          this.totalAmount = this.totalAmount - parseInt(amountValue);
        }

        (<FormArray>this.feeTempletForm.get('feeHeadArray')).removeAt(index);
        this.arr = this.feeTempletForm.controls.feeHeadArray.value;
      } else if (length == 1) {
        let data = {};
        data['message'] = 'First Row Can Not Be Deleted';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    }
  }

  getHead(id, i, event) {
    if (!event.isUserInput) {
      // Ignore if the change wasn't made by the user (e.g., programmatic change)
      return;
    }
    
    this.spinner.show();
    const payload = {};
    payload['FeeHeadId'] = id.FeeHeadId;
    this.umsService.getFeeHead(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          const data = res.data[0];
          this.FeeTable = res.data;
          this.feeHeadArray = this.feeTempletForm.get('feeHeadArray') as FormArray;
          if (this.feeHeadArray.value[i]['FeeHead'] !== '') {
            this.FeeTable.forEach((element) => {
              this.feeHeadArray.at(i).get('ClgUni').setValue(element['Uni_Colg']);
              this.feeHeadArray.at(i).get('Purpose').setValue(element['Purpose']);
            });
          } else {
            this.feeHeadArray.at(i).get('ClgUni').setValue('');
            this.feeHeadArray.at(i).get('Purpose').setValue('');
          }
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }
  

  onInputChange(event: any, i) {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.getAmount(event, i);
      this.getTotalAmount(event,i)
    }, 500);
  }

  getAmount(event: any, i) {
    let arrayData = (<FormArray>this.feeTempletForm.get('feeHeadArray')).at(i);
    let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
      .at(i)
      .get('FeeAmount').value;
    amountValue = parseInt(amountValue);
    const tempData = this.feeTempletForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    this.totalAmount = 0;
    tempData.forEach((element) => {
      if (element.FeeAmount == '') {
        element.FeeAmount = 0;
      }
      this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
    });
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.totalAmount = 0;
      this.list = false;
      this.lvl = 0;
      this.SubCast = false;
      this.editButton = false;
      this.submitButton = true;
      this.deleteButton = false;
      this.isDelete = false;
      this.FTdisable = false;
      this.isUpdate = false;
      this.feeTempletForm = this.fb.group({
        TemplateName: new FormControl('', [
          Validators.required,
          Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
        ]),
        TemplateCode: new FormControl('', [
          Validators.required,
          Validators.pattern('^[a-zA-z0-9- &\\s]*$'),
        ]),
        StudentType: new FormControl('', [Validators.required]),
        StudentStatus: new FormControl('', [Validators.required]),
        constitutional: new FormControl('', [Validators.required]),
        FeeType: new FormControl('', [Validators.required]),
        FeeLevel: new FormControl(''),
        EmId: new FormControl(''),
        EmFeeFromDate: new FormControl(''),
        EmFeeToDate: new FormControl(''),
        EmFeeType: new FormControl(''),
        // Caste: new FormControl(''),
        SocialReservation: new FormControl('', [Validators.required]),
        IsHandicap: new FormControl('', [Validators.required]),
        SchemaQuota: new FormControl('', [Validators.required]),
        AdmissionMode: new FormControl('', [Validators.required]),
        feeHeadArray: new FormArray([]),
        Currency: new FormControl('', [Validators.required]),
      });
      this.addNewRow();
    } else {
      this.list = true;
      this.editButton = true;
      this.submitButton = false;
      this.deleteButton = true;
      // this.getFacultyData();
      this.ngOnInit();
    }
  }

  getFeeHeadData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFeeHead(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.FeeHeadList = res.data;
          this.filteredHeadList = this.FeeHeadList.slice();
        } else {
          this.spinner.hide();
          this.FeeHeadList = [];
          this.filteredHeadList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchStudentType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.sTypeList = res.data;
          this.filteredsTypeList = this.sTypeList.slice();
        } else {
          this.spinner.hide();
          this.sTypeList = [];
          this.filteredsTypeList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.sTypeList = [];
        this.filteredsTypeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchSocialReservation() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.SRList = res.data;
          this.filteredSR = this.SRList.slice();
        } else {
          this.spinner.hide();
          this.SRList = [];
          this.filteredSR = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.SRList = [];
        this.filteredSR = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchStudentStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STUST';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.stuStatusList = res.data;
          this.filteredstuStatusList = this.stuStatusList.slice();
        } else {
          this.spinner.hide();
          this.stuStatusList = [];
          this.filteredstuStatusList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.stuStatusList = [];
        this.filteredstuStatusList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchAddmissionMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.AdModeList = res.data;
          this.filteredAdModeList = this.AdModeList.slice();
        } else {
          this.spinner.hide();
          this.AdModeList = [];
          this.filteredAdModeList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.AdModeList = [];
        this.filteredAdModeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchConstiCast() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.castList = res.data;
          this.filteredcastList = this.castList.slice();
        } else {
          this.spinner.hide();
          this.castList = [];
          this.filteredcastList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.castList = [];
        this.filteredcastList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchFeeType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'FT';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.feeList = res.data;
          this.filteredfeeList = this.feeList.slice();
        } else {
          this.spinner.hide();
          this.feeList = [];
          this.filteredfeeList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.feeList = [];
        this.filteredfeeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchFeeLevel() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'FLVL';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.feeLvlList = res.data;
          this.filteredfeeLvlList = this.feeLvlList.slice();
        } else {
          this.spinner.hide();
          this.feeLvlList = [];
          this.filteredfeeLvlList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.feeLvlList = [];
        this.filteredfeeLvlList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  resetControls(controlNames: string[]) {
  controlNames.forEach(name => {
    const control = this.feeTempletForm.controls[name];
    control.setValue('');
    control.setErrors(null);
    control.clearValidators();
    control.updateValueAndValidity();
    control.markAsUntouched();
  });
}

  setControlsValue(values: any) {
  Object.keys(values).forEach(key => {
    this.feeTempletForm.controls[key].setValue(values[key]);
  });
}

  toggleFlags(config: any) {
  Object.assign(this, config);
}

  FType(feeType) {
  this.feeType = feeType;
  this.FeeType = feeType;

  const clearList = [
    'SocialReservation', 'IsHandicap', 'SchemaQuota',
    'constitutional', 'Currency', 'StudentStatus', 'StudentType'
  ];

  if (feeType === 'EF') {

    this.resetControls(clearList);
    this.fetchFeeLevel();
    this.ExamFeeType();
    this.fetchSupExamInputs();

    this.toggleFlags({
      falseForExam: false,
      showFeeType: true,
      FTdisable: false,
      FeeLvlShow: true,
      FeeExam: true,
      StuType: false,
      StuStatus: false,
      AdmMode: true,
      ScRes: false,
      Handi: false,
      ScQuota: false,
      Cast: false,
      Curr: false
    });

    return;
  }

  if (feeType === 'AF') {

    this.fetchFeeLevel();
    this.ExamFeeType();
    this.fetchSupExamInputs();

    this.toggleFlags({
      falseForExam: true,
      showFeeType: true,
      FTdisable: false,
      FeeLvlShow: false,
      FeeExam: true,
      StuType: true,
      StuStatus: true,
      AdmMode: true,
      ScRes: true,
      Handi: true,
      ScQuota: true,
      Cast: true,
      Curr: true
    });

    return;
  }

  const otherTypes = ['TC', 'LC', 'MC', 'ADMC', 'TS', 'PC', 'OPC', 'RC'];

  if (otherTypes.includes(feeType)) {

    this.toggleFlags({
      falseForExam: true,
      showFeeType: false,
      FeeLvlShow: false,
      FeeExam: false,
      StuType: false,
      StuStatus: false,
      AdmMode: false,
      ScRes: false,
      Handi: false,
      ScQuota: false,
      Cast: false,
      Curr: false
    });

    this.setControlsValue({
      StudentType: ['NA'],
      StudentStatus: ['NA'],
      AdmissionMode: ['NA'],
      constitutional: ['GM'],
      IsHandicap: 'false',
      SchemaQuota: ['NA'],
      SocialReservation: ['NA']
    });
  }
}

    save() {
      this.resPending = true;
    // this.submitpayload = this.feeTempletForm.value;
    if (this.feeTempletForm.invalid) {
      this.feeTempletForm.get('TemplateName').markAsTouched();
      this.feeTempletForm.get('TemplateCode').markAsTouched();
      this.feeTempletForm.get('FeeType').markAsTouched();
      this.feeTempletForm.get('AdmissionMode').markAsTouched();
      if (this.feeTempletForm.value.FeeType == 'EF' || this.feeTempletForm.value.FeeType == 'AF') {
        // Mark these fields as untouched if FeeType is 'EF'
        this.feeTempletForm.get('StudentType').markAsUntouched();
        this.feeTempletForm.get('StudentStatus').markAsUntouched();
        this.feeTempletForm.get('SocialReservation').markAsUntouched();
        this.feeTempletForm.get('IsHandicap').markAsUntouched();
        this.feeTempletForm.get('SchemaQuota').markAsUntouched();
        this.feeTempletForm.get('Currency').markAsUntouched();
        this.feeTempletForm.get('constitutional').markAsUntouched();
      }
      else if (this.feeTempletForm.value.FeeType == 'AF') {
        this.feeTempletForm.controls['SocialReservation'].setValidators(Validators.required);
        this.feeTempletForm.controls['SocialReservation'].updateValueAndValidity();
        this.feeTempletForm.controls['SocialReservation'].markAsTouched();

        this.feeTempletForm.controls['IsHandicap'].setValidators(Validators.required);
        this.feeTempletForm.controls['IsHandicap'].updateValueAndValidity();
        this.feeTempletForm.controls['IsHandicap'].markAsTouched();

        this.feeTempletForm.controls['SchemaQuota'].setValidators(Validators.required);
        this.feeTempletForm.controls['SchemaQuota'].updateValueAndValidity();
        this.feeTempletForm.controls['SchemaQuota'].markAsTouched();

        this.feeTempletForm.controls['constitutional'].setValidators(Validators.required);
        this.feeTempletForm.controls['constitutional'].updateValueAndValidity();
        this.feeTempletForm.controls['constitutional'].markAsTouched();

        this.feeTempletForm.controls['Currency'].setValidators(Validators.required);
        this.feeTempletForm.controls['Currency'].updateValueAndValidity();
        this.feeTempletForm.controls['Currency'].markAsTouched();

        this.feeTempletForm.controls['StudentType'].setValidators(Validators.required);
        this.feeTempletForm.controls['StudentType'].updateValueAndValidity();
        this.feeTempletForm.controls['StudentType'].markAsTouched();

        this.feeTempletForm.controls['StudentStatus'].setValidators(Validators.required);
        this.feeTempletForm.controls['StudentStatus'].updateValueAndValidity();
        this.feeTempletForm.controls['StudentStatus'].markAsTouched();
      }
      else {

        // Mark these fields as touched if FeeType is not 'EF'
        this.feeTempletForm.get('StudentType').markAsTouched();
        this.feeTempletForm.get('StudentStatus').markAsTouched();
        this.feeTempletForm.get('SocialReservation').markAsTouched();
        this.feeTempletForm.get('IsHandicap').markAsTouched();
        this.feeTempletForm.get('SchemaQuota').markAsTouched();
        this.feeTempletForm.get('Currency').markAsTouched();
        this.feeTempletForm.get('constitutional').markAsTouched();

      }
      let x = (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
      x.forEach((element) => {
        element['controls']['FeeHead'].markAsTouched();
        element['controls']['FeeAmount'].markAsTouched();
      });
    } else {
      if (this.feeTempletForm.value['FeeType'] === 'TC' || this.feeTempletForm.value['FeeType'] === 'LC' || this.feeTempletForm.value['FeeType'] == 'MC' || this.feeTempletForm.value['FeeType'] == 'TS') {
        this.findDup()
      }
      else {
        this.submitFeeTemplet();
      }

    }
  }

  findDup(){
    this.spinner.show();
    const payload = {};
    this.spinner.hide();
    payload['FeeType'] = this.feeTempletForm.value['FeeType'];
    this.umsService.getFeeTclc(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        let data = {};
        data['message'] = 'Template For This FeeType Already Exist';
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
      else{
        this.spinner.hide();
        this.submitFeeTemplet();
      }
    },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.submitFeeTemplet();
    });
  }

submitFeeTemplet() {
  this.spinner.show();
  // this.submitpayload = this.feeTempletForm.value;
  this.submitpayload = this.feeTempletForm.getRawValue();

  const feeArray = this.feeTempletForm.get('feeHeadArray') as FormArray;

  let SchemaQuota = Array.isArray(this.submitpayload.SchemaQuota)
    ? this.submitpayload.SchemaQuota.join(',')
    : '';

  let SocialReservation = Array.isArray(this.submitpayload.SocialReservation)
    ? this.submitpayload.SocialReservation.join(',')
    : '';

  let StudentStatus = Array.isArray(this.submitpayload.StudentStatus)
    ? this.submitpayload.StudentStatus.join(',')
    : '';

  let StudentType = Array.isArray(this.submitpayload.StudentType)
    ? this.submitpayload.StudentType.join(',')
    : '';

  let constitutional = Array.isArray(this.submitpayload.constitutional)
    ? this.submitpayload.constitutional.join(',')
    : '';

  const toISO = (d: any) => {
    if (!d) return null;
    const date = new Date(d);
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    )).toISOString();
  };

  let completed = 0;
  const total = feeArray.length;

  feeArray.controls.forEach((control) => {
    const feeRow = control.value;

    const payload = {
      AdmissionMode: this.submitpayload.AdmissionMode,
      IsHandicap: this.submitpayload.IsHandicap,
      SchemaQuota: SchemaQuota,
      SocialReservation: SocialReservation,
      StudentStatus: StudentStatus,
      StudentType: StudentType,
      TemplateName: this.submitpayload.TemplateName,
      TemplateCode: this.submitpayload.TemplateCode,
      FeeType: this.submitpayload.FeeType,
      FeeLevel: this.submitpayload.FeeLevel,
      EmId: this.submitpayload.EmId,
      Currency: 'INR',
      constitutional: constitutional,
      FeeHead: feeRow.FeeHead,
      FeeAmount: feeRow.FeeAmount,
      EmFeeType: feeRow.EmFeeType,
      EmFeeFromDate: toISO(feeRow.EmFeeFromDate),
      EmFeeToDate: toISO(feeRow.EmFeeToDate),
      IsUpdate: this.isUpdate
    };

    this.umsService.addFeeTemplet(payload).subscribe(
      (res) => {
        this.resPending = false;
        if (!res.status) {
          this.spinner.hide();
          return;
        }

        completed++;

        if (completed === total) {
          this.spinner.hide();
          this.submitFeeHead();
        }
      },
      (err) => {
        this.spinner.hide();
      }
    );
  });
}



    submitFeeHead(fromUpdate: boolean = false) {
    this.spinner.show();
    this.submitpayload = this.feeTempletForm.value;
    let abcd = this.feeTempletForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    let cumulativeTotal =0
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        if (index === 0) {
          cumulativeTotal = parseInt(element.FeeAmount, 10);
        } else {
          cumulativeTotal = parseInt(array[0].FeeAmount, 10) + parseInt(element.FeeAmount, 10);
        }
        let arr1 = [];
        console.log('element.EmFeeFromDate',element.EmFeeFromDate);
        if (element.EmFeeFromDate) {
          const from = new Date(element.EmFeeFromDate);
          const to = new Date(element.EmFeeToDate);

          this.formattedDate = `${from.getFullYear()}-${String(from.getMonth() + 1).padStart(2, '0')}-${String(from.getDate()).padStart(2, '0')}`;
          this.formattedDate2 = `${to.getFullYear()}-${String(to.getMonth() + 1).padStart(2, '0')}-${String(to.getDate()).padStart(2, '0')}`;
        } else {
          this.formattedDate = '';
          this.formattedDate2 = '';
        }
        if(this.formattedDate == 'undefined-undefined-'){
          this.formattedDate = '';
          this.formattedDate2 = ''
        }
        
        arr1.push( 
          this.fb.group({
            TemplateCode: new FormControl(this.submitpayload.TemplateCode),
            FeeHead: new FormControl(element.FeeHead),
            FeeAmount: new FormControl(parseInt(element.FeeAmount)),
            EmFeeType: new FormControl(element.EmFeeType),
            EmFeeFromDate: new FormControl(this.formattedDate),
            EmFeeToDate: new FormControl(this.formattedDate2),
            EmFeeTotal: new FormControl(cumulativeTotal)
          })
        );
        console.log('arr1[0].value',arr1[0].value);
        this.umsService.FeeTemplet(arr1[0].value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false;
              this.errMsg = res.message;
            }
          },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          }
        );
      });
    });
    bar.then(() => {
      if (iserror == false) {
         if (fromUpdate) {
            return;
        }
        let data = {};
        data['message'] = 'Submitted Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
         this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef2.close()
        });
      } else {
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    });
  }

  editdata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  prepopulation(id) {  
    this.spinner.show();
    // this.FType(id.FeeType)
    const payload = {};
    payload['TemplateCode'] = id.TemplateCode;
    payload['FeeType'] = '';
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      if (res.status) {
        this.FeeExam = true;
        this.spinner.hide()
        let data = res.data[0];
        if (res.data[0]['FeeLevel'] != null) {
          this.fetchFeeLevel();
          this.FeeLvlShow = true;
        } else if (res.data[0]['FeeLevel'] == null) {
          this.FeeLvlShow = false;
        }
        if (res.data[0]['FeeType'] == 'AF') {
          this.FeeLvlShow = false;
        } else if (res.data[0]['FeeType'] == 'EF') {
          this.FeeLvlShow = true;
        }
        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.isDelete = false;
        this.FTdisable = false;
        // this.isUpdate = true;
        let studentType = data.StudentType.split(',');
        let StudentStatus = data.StudentStatus.split(',');
        let constitutional = data.constitutional.split(',');
        let SocialReservation = data.SocialReservation.split(',');
        let SchemaQuota = data.SchemaQuota.split(',');
        // let AdmissionMode = data.AdmissionMode.split(',')
        this.feeTempletForm = this.fb.group({
          TemplateName: new FormControl(data.TemplateName, [
            Validators.required,
          ]),
          TemplateCode: new FormControl(data.TemplateCode, [
            Validators.required,
          ]),
          StudentType: new FormControl(studentType, [Validators.required]),
          StudentStatus: new FormControl(StudentStatus, [Validators.required]),
          constitutional: new FormControl(constitutional, [
            Validators.required,
          ]),
          FeeType: new FormControl(data.FeeType, [Validators.required]),
          FeeLevel: new FormControl(data.FeeLevel),
          EmId: new FormControl(data.EmId),
          EmFeeFromDate: new FormControl(
          data.EmFeeFromDate ? new Date(data.EmFeeFromDate) : null
        ),
        EmFeeToDate: new FormControl(
          data.EmFeeToDate ? new Date(data.EmFeeToDate) : null
        ),
        EmFeeType: new FormControl(data.EmFeeType),
          Currency: new FormControl(data.Currency, [Validators.required]),
          // Caste: new FormControl(data.Caste,),
          SocialReservation: new FormControl(SocialReservation, [
            Validators.required,
          ]),
          IsHandicap: new FormControl(data.IsHandicap, [Validators.required]),
          SchemaQuota: new FormControl(SchemaQuota, [Validators.required]),
          AdmissionMode: new FormControl(data.AdmissionMode, [
            Validators.required,
          ]),
          feeHeadArray: new FormArray([]),
        });
        this.filteredExamFeeTypeList = [...this.ExamFeeTypeList];

        const backendValue = res.data[0].EmFeeType;
        this.feeTempletForm.patchValue({ EmFeeType: backendValue }, { emitEvent: false });

        this.feeTempletForm.get('FeeType').updateValueAndValidity();
        this.FType(data.FeeType);

        setTimeout(() => {
        const schemaVal = this.feeTempletForm.get('SchemaQuota')?.value;

        if (schemaVal?.includes('OS')) {
        this.onSchemaQuotaChange(['OS']);
      }
      }, 0);

        this.isUpdate = true; 
        this.FeeTable = res.data;
        this.arr = this.FeeTable;
        this.FeeTable.forEach((element, i) => {
          const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
          this.originalFeeDates[i] = {
          from: element.EmFeeFromDate,
          to: element.EmFeeToDate,
          feeType: element.EmFeeType
        };
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              ClgUni: new FormControl(element.Uni_Colg),
              Purpose: new FormControl(element.Purpose),
              FeeAmount: new FormControl(element.FeeAmount, [
                Validators.required,
                Validators.pattern('^[0-9]*$'),
              ]),
              EmFeeType: new FormControl(element.EmFeeType),
              EmFeeFromDate: new FormControl(
              element.EmFeeFromDate ? new Date(element.EmFeeFromDate) : null
            ),
            EmFeeToDate: new FormControl(
              element.EmFeeToDate ? new Date(element.EmFeeToDate) : null
            ),
            })
          );
          setTimeout(() => {
            creds.at(i).get('EmFeeType')?.setValue(element.EmFeeType);
            this.getdates(element.EmFeeType, i);
          }, 300);
          this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
        });
        // this.fetchCast(data.constitutional)
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  update() {
    this.resPending = true;
  const feeType = this.feeTempletForm.value.FeeType;
  const efNotRequiredFields = [
    'StudentType',
    'StudentStatus',
    'SocialReservation',
    'IsHandicap',
    'SchemaQuota',
    'Currency',
    'constitutional'
  ];

  if (feeType === 'EF' || feeType === 'RE') {
    efNotRequiredFields.forEach(field => {
      const control = this.feeTempletForm.get(field);
      control?.clearValidators();
      control?.setErrors(null);
      control?.updateValueAndValidity({ emitEvent: false });
    });
  }

    this.submitpayload = this.feeTempletForm.value;

  // Object.entries(this.feeTempletForm.controls).forEach(([key, value]: any) => {
  //   console.log(`${key}: ${value.status}`);
  // });

  if (this.feeTempletForm.invalid) {
    this.feeTempletForm.get('TemplateName')?.markAsTouched();
    this.feeTempletForm.get('TemplateCode')?.markAsTouched();
    this.feeTempletForm.get('FeeType')?.markAsTouched();
    this.feeTempletForm.get('AdmissionMode')?.markAsTouched();

    if (feeType !== 'EF' && feeType !== 'RE') {
      this.feeTempletForm.get('StudentType')?.markAsTouched();
      this.feeTempletForm.get('StudentStatus')?.markAsTouched();
      this.feeTempletForm.get('SocialReservation')?.markAsTouched();
      this.feeTempletForm.get('IsHandicap')?.markAsTouched();
      this.feeTempletForm.get('SchemaQuota')?.markAsTouched();
      this.feeTempletForm.get('Currency')?.markAsTouched();
      this.feeTempletForm.get('constitutional')?.markAsTouched();
    }

    const rows = (this.feeTempletForm.get('feeHeadArray') as FormArray).controls;
    rows.forEach(r => {
      r.get('FeeHead')?.markAsTouched();
      r.get('FeeAmount')?.markAsTouched();
    });

    return;
  }
      this.updateFeeTemplet();
}

  updateFeeTemplet() {
  this.spinner.show();
  // this.submitpayload = this.feeTempletForm.value;
  this.submitpayload = this.feeTempletForm.getRawValue();

  const feeArray = this.feeTempletForm.get('feeHeadArray') as FormArray;

  let SchemaQuota = Array.isArray(this.submitpayload.SchemaQuota)
    ? this.submitpayload.SchemaQuota.join(',')
    : '';

  let SocialReservation = Array.isArray(this.submitpayload.SocialReservation)
    ? this.submitpayload.SocialReservation.join(',')
    : '';

  let StudentStatus = Array.isArray(this.submitpayload.StudentStatus)
    ? this.submitpayload.StudentStatus.join(',')
    : '';

  let StudentType = Array.isArray(this.submitpayload.StudentType)
    ? this.submitpayload.StudentType.join(',')
    : '';

  let constitutional = Array.isArray(this.submitpayload.constitutional)
    ? this.submitpayload.constitutional.join(',')
    : '';

  const toISO = (d: any) => {
    if (!d) return null;
    const date = new Date(d);
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    )).toISOString();
  };

  let completed = 0;
  const total = feeArray.length;
  feeArray.controls.forEach((control,feetemplateindex) => {
    const feeRow = control.value;
    const payload = {
      AdmissionMode: this.submitpayload.AdmissionMode,
      IsHandicap: this.submitpayload.IsHandicap,
      SchemaQuota: SchemaQuota,
      SocialReservation: SocialReservation,
      StudentStatus: StudentStatus,
      StudentType: StudentType,
      TemplateName: this.submitpayload.TemplateName,
      TemplateCode: this.submitpayload.TemplateCode,
      FeeType: this.submitpayload.FeeType,
      FeeLevel: this.submitpayload.FeeLevel,
      EmId: this.submitpayload.EmId,
      Currency: 'INR',
      constitutional: constitutional,
      FeeHead: feeRow.FeeHead,
      FeeAmount: feeRow.FeeAmount,
      EmFeeType: feeRow.EmFeeType,
      EmFeeFromDate: toISO(feeRow.EmFeeFromDate),
      EmFeeToDate: toISO(feeRow.EmFeeToDate),
      IsUpdate: true
    };
    let amdFunction = 'updateFeeTemplet';
    if ((feetemplateindex + 1) > this.arr.length) {
      amdFunction = 'addFeeTemplet';
    }
    this.umsService[amdFunction](payload).subscribe(
      (res) => {
        this.resPending = false;
        if (!res.status) {
          this.spinner.hide();
          return;
        }

        completed++;

        if (completed === total) {
          this.spinner.hide();
          let data = {};
          data['message'] = 'Updated Successfully';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';

        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
        );
         this.dialogRef.afterClosed().subscribe(result => {
          this.dialogRef2.close()
        });
          this.submitFeeHead(true);
        }
      },
      (err) => {
        this.spinner.hide();
      }
    );
  });
}

    updateFee() {
    this.spinner.show();
    this.submitpayload = this.feeTempletForm.value;
    let abcd = this.feeTempletForm.get('feeHeadArray') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            TemplateCode: new FormControl(this.submitpayload.TemplateCode),
            FeeHead: new FormControl(element.FeeHead),
            FeeAmount: new FormControl(element.FeeAmount),
            EmFeeType: new FormControl(element.EmFeeType),
            EmFeeFromDate: new FormControl(element.EmFeeFromDate),
            EmFeeToDate: new FormControl(element.EmFeeToDate),
            EmFeeTotal: new FormControl('')
          })
        );
        this.umsService.updateFeeTemplet(arr1[0].value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false;
              this.errMsg = res.message;
            }
          },
          (ERROR: HttpErrorResponse) => {
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          }
        );
      });
    });
    bar.then(() => {
      if (iserror == false) {
        let data = {};
        data['message'] = 'Submitted Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      } else {
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    });
  }

  deletedata(e, k) {
    if (e === 'true') {
      this.list = false;
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  prepopulationForDelete(id) {
    this.spinner.show()
    const payload = {};
    payload['TemplateCode'] = id.TemplateCode;
    payload['FeeType'] = '';
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        let data = res.data[0];
        if (res.data[0]['FeeLevel'] != null) {
          this.fetchFeeLevel();
          this.FeeLvlShow = true;
        } else if (res.data[0]['FeeLevel'] == null) {
          this.FeeLvlShow = false;
        }
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        this.isDelete = true;
        this.FTdisable = false;
        this.isUpdate = false;
        let studentType = data.StudentType.split(',');
        let StudentStatus = data.StudentStatus.split(',');
        let constitutional = data.constitutional.split(',');
        let SocialReservation = data.SocialReservation.split(',');
        let SchemaQuota = data.SchemaQuota.split(',');
        // let AdmissionMode = data.AdmissionMode.split(',')
        this.feeTempletForm = this.fb.group({
          TemplateName: new FormControl(data.TemplateName, [
            Validators.required,
          ]),
          TemplateCode: new FormControl(data.TemplateCode, [
            Validators.required,
          ]),
          StudentType: new FormControl(studentType, [Validators.required]),
          StudentStatus: new FormControl(StudentStatus, [Validators.required]),
          constitutional: new FormControl(constitutional, [
            Validators.required,
          ]),
          FeeType: new FormControl(data.FeeType, [Validators.required]),
          FeeLevel: new FormControl(data.FeeLevel),
          EmId: new FormControl(data.EmId),
          Currency: new FormControl(data.Currency, [Validators.required]),
          // Caste: new FormControl(data.Caste,),
          SocialReservation: new FormControl(SocialReservation, [
            Validators.required,
          ]),
          IsHandicap: new FormControl(data.IsHandicap, [Validators.required]),
          SchemaQuota: new FormControl(SchemaQuota, [Validators.required]),
          AdmissionMode: new FormControl(data.AdmissionMode, [
            Validators.required,
          ]),
          feeHeadArray: new FormArray([]),
        });
        this.FeeTable = res.data;
        this.FeeTable.forEach((element, i) => {
          const dateStr = element.EmFeeFromDate; // your input date string in dd-mm-yyyy format
        const [day, month, year] = dateStr.split('-');
        // Convert to yyyy-mm-dd format
        const formattedFromDate = `${year}-${month}-${day}`;
        
        const dateStr2 = element.EmFeeToDate; // your input date string in dd-mm-yyyy format
        const [day2, month2, year2] = dateStr2.split('-');
        // Convert to yyyy-mm-dd format
        const formattedToDate = `${year2}-${month2}-${day2}`;
          const creds = this.feeTempletForm.controls.feeHeadArray as FormArray;
          creds.push(
            this.fb.group({
              FeeHead: new FormControl(element.FeeHead, [Validators.required]),
              ClgUni: new FormControl(element.Uni_Colg),
              Purpose: new FormControl(element.Purpose),
              FeeAmount: new FormControl(element.FeeAmount, [
                Validators.required,
                Validators.pattern('^[0-9]*$'),
              ]),
              EmFeeType: new FormControl(element.EmFeeType),
              EmFeeFromDate: new FormControl(formattedFromDate),
              EmFeeToDate: new FormControl(formattedToDate),
              EmFeeTotal: new FormControl(''),
            })
          );
          this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
        });
      } else {
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  DeletetheRecord() {
    const data = {};
    // data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['message'] =
      'For this template code all mapped criteria will be deleted, do you want to continue?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.delete(this.feeTempletForm.value);
        this.dialogRef2.close();
      } else {
        // this.ngOnInit();
        this.dialogRef2.close();
      }
    });
  }

  delete(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        TemplateName: id.TemplateName,
        TemplateCode: id.TemplateCode,
        StudentType: id.StudentType[0],
        StudentStatus: id.StudentStatus[0],
        constitutional: id.constitutional[0],
        FeeType: id.FeeType,
        FeeLevel: id.FeeLevel[0],
        EmId: id.EmId[0],
        Currency: id.Currency,
        // Caste: id.Caste,
        SocialReservation: id.SocialReservation[0],
        IsHandicap: id.IsHandicap,
        SchemaQuota: id.SchemaQuota[0],
        AdmissionMode: id.AdmissionMode[0],
        FeeAmount: id.feeHeadArray[0]['FeeAmount'],
        FeeHead: id.feeHeadArray[0]['FeeHead'],
        // FeeHead: id.FeeHead,
        // FeeAmount: id.FeeAmount,
      },
    };
    this.httpClient
      .delete(this.APIService + '/fees/feetemplate', options)
      .subscribe(
        (s) => {
          this.spinner.hide();
          // this.spinner.hide();
          let cc = [];
          cc.push(s);
          let data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ngOnInit();
          });
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
          // this.umsService.openSnackbar(ERROR.error.message);
        }
      );
  }

  clickHead(item, i) {
    let tempHead = [];
    this.headdList[i] = [];
    let ClgUni = item.Uni_Colg;
    let Purpose = item.Purpose;
    let tempsrno = [];
    let tempArr = this.feeTempletForm.get('feeHeadArray').value;
    let control = (<FormArray>this.feeTempletForm.get('feeHeadArray')).at(i);
    control.patchValue({
      ClgUni: ClgUni,
      Purpose: Purpose,
    });
    const payload = {};
    this.umsService.getFeeHead(payload).subscribe((res) => {
      let data = res.data;
      if (res.message !== 'No Data Found') {
        res.data.forEach((element) => {
          tempsrno.push(element);
        });

        this.headdList[i] = tempsrno;
        let feeHeadd = control.get('FeeHead').value;
        tempHead = this.headdList[i];
        tempArr.forEach((element) => {
          if (element.FeeHead == feeHeadd) {
            tempHead = tempHead.filter((m) => m.HeadCode != element.FeeHead);
          }
        });
        this.headdList[i] = tempHead;
      } else {
        this.headdList[i] = [];
      }
    });
  }

  fetchCurrency() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'CU';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide()
          this.CurrencyList = res.data;
          this.filteredCurrencyList = this.CurrencyList.slice();
        } else {
          this.spinner.hide()
          this.CurrencyList = [];
          this.filteredCurrencyList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        this.CurrencyList = [];
        this.filteredCurrencyList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  changeCurreancy(item) {
    if (item == 'NRI') {
      this.feeTempletForm.controls['Currency'].setValue('USD');
    } else {
      this.feeTempletForm.controls['Currency'].setValue('INR');
    }
  }

  getExamList() {
    this.spinner.show();
    const payload = {};
    this.umsService.getExam(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.examList = res.data;
          this.filteredListExam = this.examList.slice();
        } else {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);
      }
    );
  }

getdates(emFeeType:string, i:number) {
  this.cutoffLoaded = false;
  const payload = {
    SessionId: this.SessionNo,
    EmId: this.feeTempletForm.value.EmId,
    InCode:''
  };
  if(this.feeTempletForm.controls.FeeType?.value=='AF'){payload['InCode']='ADFEE'}
  if(this.feeTempletForm.controls.FeeType?.value=='EF'){payload['InCode']='EMFEE'}

  this.umsService.getExamFeeSessionCutOff(payload).subscribe(res => {
    if (res.status && res.data?.length) {

      const cutoff = res.data[0];

      this.sessionCutoffFrom = new Date(cutoff.CutOffDateFrom);
      this.sessionCutoffTo = new Date(cutoff.CutOffDate);
      this.cutoffLoaded = true;

      this.showDateInfoMsg = true;
      this.dateInfoMsg =
        `⚠️ The session cutoff period is from ` +
        `${this.formatDate(this.sessionCutoffFrom)} to ` +
        `${this.formatDate(this.sessionCutoffTo)}.
        Regular Fee and Late Fee can be selected only within this date range.`;
    }
    else {
      this.cutoffLoaded = false;
      this.showDateInfoMsg = false;
    }
  });
}

    fetchSupExamInputs() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ACT';
    this.umsService.getCode(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamInputList = res.data;
        this.filteredExamInputList = this.ExamInputList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      })
  }

  compareEmFeeType(a: string, b: string) {
  return a === b;
}


  ExamFeeType(callback?: () => void) {
  this.spinner.show();

  const payload = { CdType: 'ExFTY' };

  this.umsService.getCode(payload).subscribe(res => {
    this.spinner.hide();

    if (res.status && res.data) {

      this.ExamFeeTypeList = res.data;

      this.filteredExamFeeTypeList = this.ExamFeeTypeList;

      if (callback) callback();

    } else {
      this.ExamFeeTypeList = [];
      this.filteredExamFeeTypeList = [];
      if (callback) callback();
    }
  }, () => {
    this.spinner.hide();
    this.ExamFeeTypeList = [];
    this.filteredExamFeeTypeList = [];
    if (callback) callback();
  });
}

    arrEnable(item:any){
    this.courseType = item.CourseType
    this.isFeeType = false;
    let arrayData = (<FormArray>this.feeTempletForm.get('feeHeadArray'))
    arrayData.reset();
  }

    fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    }
    );
  }

    getTotalAmount(event: any, i) {
    let arrayData = (<FormArray>this.feeTempletForm.get('feeHeadArray')).at(i);
    let amountValue = (<FormArray>this.feeTempletForm.get('feeHeadArray')).at(i).get('FeeAmount').value;
    amountValue = parseInt(amountValue);
    const tempData = this.feeTempletForm.controls.feeHeadArray.value;
    this.arrTest = tempData;
    this.totalAmount = 0

    tempData.forEach((element) => {
    let amt = parseInt(element.FeeAmount) || 0;
    this.totalAmount += amt;
      // if (element.FeeAmount == '') {
      //   element.FeeAmount = 0;
      // }
      // this.totalAmount = this.totalAmount + parseInt(element.FeeAmount);
    });
  }
}
 
 
